
import { useUUID } from "@/hooks/useUUID";
import { watcherService } from "@/services/watcherService";
import { getPathname } from "@/utils";
import { computed, defineComponent, toRefs } from "vue";

export default defineComponent({
	props: {
		sitemap: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const { sitemap } = toRefs(props);

		const {
			sitemapStats,
			removeSitemap,
			continueWatching,
			pauseWatching,
			seenStatuses,
			setSitemapVisibility,
			setSitemapRandomize,
		} = watcherService;
		const stats = computed(() => sitemapStats.value[sitemap.value]);

		const handleRemove = () => removeSitemap(sitemap.value);

		const running = computed(
			() => sitemapStats.value[sitemap.value].running
		);
		const toggleStatus = () => {
			if (running.value) {
				pauseWatching(sitemap.value);
			} else {
				continueWatching(sitemap.value);
			}
		};

		const visible = computed(() => stats.value.show);
		const toggleVisibility = () => {
			setSitemapVisibility(sitemap.value, !visible.value);
		};

		const randomize = computed(() => stats.value.randomize);
		const toggleRandomizeSitemap = () => {
			setSitemapRandomize(sitemap.value, !randomize.value);
		};

		const componentUUID = useUUID();
		const randomizeCheckboxId = `randomize-checkbox-${componentUUID.value}`;

		return {
			pathname: getPathname(sitemap.value),
			stats,
			seenStatuses,

			handleRemove,

			running,
			toggleStatus,

			visible,
			toggleVisibility,

			randomize,
			toggleRandomizeSitemap,

			componentUUID,
			randomizeCheckboxId,
		};
	},
});
